import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import {
  SignupCard,
  EmailSignupForm,
  SubmitGoButton,
} from '@streamlabs-core/sl-one-fe-components-vue2';
import feSdk from '@streamlabs-core/sl-one-fe-sdk';
import { EAnalyticsEvent } from '@/helpers/analytic';
import UtilHelper from '@/helpers/utils';
import { EUserAdEvent } from '@/helpers/user';
import { renderTurnstile, turnstileKey } from '@/components/turnstile.js';

interface Window {
  turnstile: any;
}

const win = (window as any) as Window;

@Component({
  components: {
    SignupCard,
    EmailSignupForm,
    SubmitGoButton,
  },
})
export default class SLSignupForm extends Base {
  intent = 'connect';
  formDisabled: boolean = false;
  promotionalConsentRequired: boolean = false;
  turnstileKey = turnstileKey;
  widgetId = null;
  widgetToken = null;

  mounted() {
    renderTurnstile((widgetToken) => {
      this.widgetToken = widgetToken;
    }, true)
      .then(({ widgetId }) => {
        this.widgetId = widgetId;
      })
      .catch((err) => {
        console.error('error rendering captcha', err);
      });
  }

  async onSlidSignupAttempt(data) {
    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginAttempt);
  }

  async onSlidSignup(sessionUser) {
    await this.slidModule.setSLIDSession(sessionUser);

    if (sessionUser.email_verified === false) {
      return this.handleVerificationRequired('email');
    }

    this.formDisabled = true;

    try {
      await this.startDirectConnect();

      setTimeout(() => {
        this.formDisabled = false;
      }, 15000);
    } catch (err) {
      this.formDisabled = false;
    }

    return true;
  }

  onPlatformAuth(data) {
    const platform = data[0];

    this.$sla.sendEvent(EAnalyticsEvent.loginButtonClicked);

    switch (platform) {
      case 'twitch':
        window.open('/auth/twitch', '_self');
        UtilHelper.trackGTMEvent({ event: EUserAdEvent.logIn });
        break;
      default:
        break;
    }
  }

  onRedirectRequested(to: string) {
    if (to === 'login')
      this.$router.push('/login');

    if (to === 'email')
      this.$router.push('/verify-email');

    if (to === 'tfa')
      this.$router.push('/verify-tfa');
  }

  handleVerificationRequired(type) {
    if (type === 'email') this.onRedirectRequested('email');
    // We may need to redirect user to 2ft
    // Age Gatting
    // Email verification
  }

  async startDirectConnect() {
    const { redirect_url } = await feSdk.api.identity.connectIdentity({
      origin: window.location.origin,
      pk: feSdk.env.get().services.identity.pk,
      intent: this.intent,
      state: btoa(JSON.stringify({ r: '/projects' })),
    });

    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginSuccess);
    window.location.href = redirect_url;
  }

  onSignupError(msg) {
    console.warn(`Error signing up: ${msg}`);
    this.$sla.sendEvent(EAnalyticsEvent.slNativeLoginFailure, { error: msg });

    if (this.widgetId) {
      // reset / reload widget on errors returned.
      this.widgetToken = '';
      win.turnstile.reset(this.widgetId);
    }
  }
}


